import { ArrowDownUp, CalendarMinus } from 'react-bootstrap-icons';
import {
  StyledOfferProductIcon,
  StyledPriceGreyCard,
  StyledProductDetails,
  StyledProductLeadTime
} from './ResultsStyles';
import {
  getQualificationItemBillingZone,
  getQualificationItemDelay,
  makeAvailableDateBadge,
  makeUnavailabilityReasonBadge
} from '../../helper';

import Badge from '@designSystem/Badges';
import { IOfferingResult } from '../../interfaces';
import Icon from '@designSystem/Icon';
import ProductPriceAndFees from '../productDetail/ProductPriceAndFees';
import React from 'react';
import { billingZoneMap } from '../constants';
import theme from '@theme';
import { useGuardHook } from '../../../../utils/FeatureFlag';
import { useTranslation } from 'react-i18next';

const ResultsItem: React.FC<{
  row: IOfferingResult;
}> = ({ row }) => {
  const billingZone = getQualificationItemBillingZone(row);
  const { t } = useTranslation();
  const canDisplayPrice = useGuardHook('display_product_price');

  const needStudy = row.qualificationItemResult?.toUpperCase() === 'TO_BE_STUDIED';
  const shouldDisplayPriceAndFees = !!row.product.productPrice?.length;

  return (
    <>
      {makeUnavailabilityReasonBadge(row)}
      {makeAvailableDateBadge(row)}
      {billingZone && (
        <Badge
          variant={billingZoneMap[billingZone]?.badgeVariant || 'blue'}
          style={{ marginLeft: '6px' }}
        >
          {billingZoneMap[billingZone]?.label || ''}
        </Badge>
      )}
      <StyledProductDetails>
        <div style={{ display: 'flex' }}>
          <StyledOfferProductIcon>
            <Icon iconSize="1rem" round>
              <ArrowDownUp />
            </Icon>
          </StyledOfferProductIcon>
          <div style={{ paddingRight: 12 }}>{row.product.productOffering.name}</div>
        </div>
      </StyledProductDetails>
      {row.leadTime && (
        <StyledProductLeadTime>
          <div style={{ marginRight: 4 }}>
            <CalendarMinus size={16} color={theme.palette.grey[400]} />
          </div>
          {t('features.eligibility.products.results.leadTime', 'Lead time')}{' '}
          {getQualificationItemDelay(row)}
        </StyledProductLeadTime>
      )}
      {canDisplayPrice && (shouldDisplayPriceAndFees || needStudy) && (
        <StyledPriceGreyCard>
          <ProductPriceAndFees product={row} />
        </StyledPriceGreyCard>
      )}
    </>
  );
};

export default ResultsItem;
